module.exports = __webpack_public_path__ + "static/media/downloadFileManifestIcon.7e95b699.svg";